/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOptionGroup = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5 19v2H3v-2zm16 0v2h-2v-2zM9.001 19v2H7v-2zM13 19v2h-2v-2zm4.001 0v2H15v-2zM5 14.999V17H3v-2.001zm16 0V17h-2v-2.001zM13 7v3.586l1.293-1.293 1.414 1.414L12 14.414l-3.707-3.707 1.414-1.414L11 10.586V7zm-8 4v2H3v-2zm16 0v2h-2v-2zM5 6.999V9H3V6.999zm16 0V9h-2V6.999zM9.001 3v2H7V3zM5 3v2H3V3zm8 0v2h-2V3zm4.001 0v2H15V3zM21 3v2h-2V3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgOptionGroup as OptionGroup };
